export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmation"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oui"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Êtes-vous sûr de vouloir continuer ?"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Supprimer le crypto-actif"])}
}